module.exports = __webpack_public_path__ + "static/media/photo.b6f981cf.jpg";